import Image from 'next/image';
import { Button, Typography } from '@/components/common';
import { Title } from '@/components/landing/title';
import AppRoutes from '@/const/routes';
import { customEvent } from '@/lib';
import Images from '@/const/images';
import { useRouter } from 'next/router';
import clsx from 'clsx';

export const GetStarted = () => {
	const { pathname } = useRouter();
	const logoUrl = Images.logo;
	const showHat = pathname === AppRoutes.LANDING_CASES;

	return (
		<div className="py-12 xl:py-0 relative">
			<div className="absolute top-0 left-0 w-full pointer-events-none h-[500px]">
				<Image
					src="/img/landing/lines-green.png"
					alt="lines background"
					fill
					className="object-contain 3xl:object-cover object-center hidden xl:block"
				/>
			</div>
			<div
				className="flex flex-col items-center justify-center
				bg-gradient-to-b from-[#f7f7fb] to-[#F4F4F9] px-4 xl:h-[550px]"
			>
				<Title
					description="You Legal Journey Made Fast and Easy"
					className="xl:mt-36"
					typographyDescription="regular-28"
				>
					Get Started <span className="text-primary">Today</span>
				</Title>
				<div className="flex flex-col md:flex-row gap-2 items-center text-center md:mt-4">
					<Typography type="regular-24" text="No Upfront Cost with" />
					<Image
						src={logoUrl}
						width={197}
						height={36}
						alt="Magic"
						quality={50}
						loading="lazy"
					/>
				</div>
				<Button
					decoration="primary"
					size="large"
					className="mt-9 md:!w-[12.188rem]"
					onClick={() => {
						customEvent({
							action: 'sign_up_click',
							category: 'landing',
							label: 'Sign-up',
							value: 'Sign-up',
							callback: () =>
								window.open(AppRoutes.CLIENTAPP_AUTH_SIGN_UP, '_blank'),
						});
					}}
				>
					Apply Now
				</Button>
			</div>
			<div
				className={clsx(
					'hidden xl:block absolute right-0 top-[50px] 2xl:top-[80px]',
					{
						'!hidden': !showHat,
					}
				)}
			>
				<Image
					src="/img/landing/hat-cut.png"
					alt="hat"
					width={0}
					height={0}
					sizes="100vw"
					className="w-full h-full"
					quality={75}
					priority
				/>
			</div>
			{/* </div> */}
		</div>
	);
};
